import React from "react";
import { useNavigate } from "react-router-dom";

import ProjectWorkspace from "../components/ProjectWorkspace";
import { useProjects } from "../hooks/useProjects";

export default function WorkspacesHome({ user }) {
  const navigate = useNavigate();
  const { projects, create, remove } = useProjects(user?.uid);

  const handleCreate = async (name) => {
    const id = await create(name);
    if (id) navigate(`/workspace/${id}`);
    return id;
  };

  const handleSelect = (project) => {
    navigate(`/workspace/${project.id}`);
  };

  const handleDelete = async (projectId) => {
    const project = projects.find((p) => p.id === projectId);
    const label = project?.name || "this workspace";
    const shouldDelete = window.confirm(
      `Delete workspace "${label}"? This action cannot be undone.`,
    );
    if (!shouldDelete) return;
    await remove(projectId);
  };

  return (
    <ProjectWorkspace
      projects={projects}
      onCreate={handleCreate}
      onSelect={handleSelect}
      onDelete={handleDelete}
    />
  );
}
